import React from 'react';
import styles from './RadioPillGroup.module.css';

export type RadioPillOption = string | { value: string; label: string };

interface RadioPillGroupProps {
  options: RadioPillOption[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  wrap?: boolean;
  className?: string;
}

const getOptionValue = (opt: RadioPillOption) => (typeof opt === 'string' ? opt : opt.value);
const getOptionLabel = (opt: RadioPillOption) => (typeof opt === 'string' ? opt : opt.label);

const RadioPillGroup: React.FC<RadioPillGroupProps> = ({
  options,
  value,
  onChange,
  disabled = false,
  wrap = false,
  className = '',
}) => {
  const groupCls = [
    styles.group,
    wrap ? styles.wrap : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={groupCls}>
      {options.map((option) => {
        const optVal = getOptionValue(option);
        return (
          <button
            key={optVal}
            type="button"
            className={`${styles.pill} ${value === optVal ? styles.pillSelected : ''}`}
            onClick={() => onChange(optVal)}
            disabled={disabled}
          >
            {getOptionLabel(option)}
          </button>
        );
      })}
    </div>
  );
};

export default RadioPillGroup;
